import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { CompanyRelationshipTypeApiService } from '../../empresas/services/company-relationship-type-api.service';
import { CompanyRelationshipType } from '../../empresas/models/empresa.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-company-relationship-type-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './company-relationship-type-list.component.html'
})
export class CompanyRelationshipTypeListComponent implements OnInit {
  items: CompanyRelationshipType[] = [];
  loading = false;
  error = '';

  constructor(
    private api: CompanyRelationshipTypeApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll({ page: 0, size: 100 }).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los tipos de relación';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-empresas/tipos-relacion/crear']);
  }

  editar(item: CompanyRelationshipType): void {
    this.router.navigate(['/config-empresas/tipos-relacion/editar', item.id]);
  }

  async eliminar(item: CompanyRelationshipType): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar tipo de relación',
      message: `¿Está seguro de eliminar el tipo de relación "${item.name}"?`
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Tipo de relación', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el tipo de relación' });
      }
    });
  }
}
